import React, { Component } from 'react';
import lang, {currentLanguage} from '../services/lang';
import { Link, hashHistory } from 'react-router';
import Icon from '../components/Icon';
import YouTube from 'react-youtube';
import './welcome.css';
import { trackView } from '../services/analytics';

export default class Videos extends Component {
  constructor() {
    super();
    this.state = {
      videoWidth: window.innerWidth,
      videoHeight: window.innerHeight - 55,
    };

    trackView("Welcome");
  }
  
  componentDidMount() {
    this.setSize();
    window.addEventListener('resize', this.setSize);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.setSize);
  }
  
  setSize = () => {
    this.setState({
      videoWidth: window.innerWidth,
      videoHeight: window.innerHeight - 55,
    });
  }
  
  render() {
    const { videoWidth, videoHeight } = this.state;
    const opts = {
      height: videoHeight,
      width: videoWidth,
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1,
        controls: 0,
        showinfo: 0,
        modestbranding: 1,
        rel: 0,
        disablekb: 1,
        cc_load_policy: 1,
        cc_lang_pref: language,
      }
    };

    const language = currentLanguage();
    
    return (
      <div className="welcome">
        <div className="welcome-content">
          <YouTube
            opts={opts}
            videoId="BhAzJ5Y632U"
            onEnd={() => hashHistory.push('/learn')}
          />
          <div className="welcome-clickblock"></div>
        </div>
        <div className="welcome-menu-row">
          <div className="welcome-menu">
            <Link to="/learn" className="welcome-menu-subtitle">{lang('learn-about-clinical-trials')}</Link>
            <Link to="/menu" className="welcome-menu-main">
              {lang('main-menu')} <Icon name="menuWhite" className="welcome-menu-main-icon"/>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Welcome.js